/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ServerRequest } from "@lib/shared/types";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosError, AxiosRequestConfig } from "axios";
import { RouteConfig } from "@page-builder/ts/types";
import { getTestVariantId, setTestVariantId } from "@lib/shared/cookies";
import { ServerResponse } from "http";
interface RouteConfigResponse {
    data: RouteConfig | null;
    success: boolean;
}

export const getRouteConfig = async ({
    req,
    res,
    slug,
    templateId,
}: {
    req: ServerRequest;
    slug: string;
    res?: ServerResponse;
    templateId?: string;
}): Promise<{ data: RouteConfig | null; error: AxiosError | null }> => {
    const accessToken = req.accessToken;
    const variantId = getTestVariantId("template", null, req, res);

    const previewMode = req.query?.previewPb as string;

    const parsedVariantId = parseInt(variantId as string, 10);

    const config: AxiosRequestConfig = {
        method: "get",
        url: `/api/web/v1/templates?uri=${slug}${
            templateId ? `&customTemplateId=${templateId}` : ""
        }${parsedVariantId ? `&variantId=${parsedVariantId}` : ""}${
            previewMode ? `&preview=${previewMode}` : ""
        }`,
        headers: {
            "X-DOMAIN-NAME": `${req.headers?.host ?? ""}`,
            Authorization: `Bearer ${accessToken as string}`,
            "X-Language": req.locale ?? "en",
        },
    };
    const { data: routeConfigResponse, error } =
        await apiHandler<RouteConfigResponse>(() => HTTP.server(config));

    if (routeConfigResponse?.data) {
        setTestVariantId(
            "template",
            String(routeConfigResponse.data.testConfig?.variantId),
            null,
            req,
            res,
        );
    }

    return {
        data: routeConfigResponse?.data ?? null,
        error,
    };
};
